import { defaultStoreState } from '../state-defaults';
import type {
    StateGetter,
    StateSetter,
    UiCoreQuestionFormState,
    UiState,
} from '../state-types';
import { answersActions } from './answers/answers-actions';
import { cardsActions } from './cards/cards-actions';
import { coreQuestionsActions } from './core-questions/core-questions-actions';
import { surveyActions } from './survey/survey-actions';
import { checkIsOkToSwitchCoreQuestionForm } from './ui-core-question-form/check-is-ok-to-switch-core-question-form';
import { updateUiCoreQuestionForm } from './ui-core-question-form/update-ui-core-question-form';
import { updateUi } from './update-ui';

export type Actions = ReturnType<typeof actions>;

export const actions = (set: StateSetter, get: StateGetter) => ({
    /** Reset the store state to its initial state */
    reset: () => set((s) => ({ ...s, ...defaultStoreState }), true),

    ...surveyActions(set, get),
    ...cardsActions(set, get),
    ...answersActions(set, get),
    ...coreQuestionsActions(set, get),

    /**********************************
     * UI
     **********************************/

    /** Update UI partially */
    updateUi: (partialUi: Partial<UiState>) => set(updateUi(partialUi), true),

    /**********************************
     * UI CORE QUESTION FORM
     **********************************/

    /** Update UI Core Question Form partially */
    updateUiCoreQuestionForm: (
        partialUiCoreQuestionForm: Partial<UiCoreQuestionFormState>
    ) => set(updateUiCoreQuestionForm(partialUiCoreQuestionForm), true),

    /** Check if it's ok (form dirty..) to switch to a new Core Question form */
    checkIsOkToSwitchCoreQuestionForm: (
        activeCardId: string = '',
        coreQuestionId: string = ''
    ) => checkIsOkToSwitchCoreQuestionForm(activeCardId, coreQuestionId)(get()),
});
